import { Box, Card, Grid } from "@mui/material";
import { changePassword } from "Apis/signIn";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useFormik } from "formik";
import React, { useContext } from "react";
import * as Yup from "yup";
import { LoginFormContext } from "context/LoginFormContext";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

const ChangePassword = () => {
  const { setNotification } = useContext(LoginFormContext);
  const { sideNav } = colors;

  const passwordRequirements = [
    "Min six characters (ન્યૂનતમ છ અક્ષરો)",
    "At least one digit (ઓછામાં ઓછું એક અંક હોવો જોઈએ)",
    "At least one lowercase letter (એક નાનું (a-z) અક્ષર જરૂર હોવું જોઈએ)",
    "At least one uppercase letter (એક મોટાં (A-Z) અક્ષર હોવું જોઈએ)",
    "At least one special character (ઓછામાં ઓછું એક વિશેષ ચિહ્ન હોવું જોઈએ)",
  ];
  const renderPasswordRequired = passwordRequirements.map((item, key) => {
    const passKey = `element-${key}`;
    return (
      <MDBox key={passKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });
  const initialValues = {
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  };
  const ValidationSchema = Yup.object({
    old_password: Yup.string().required("Old password is required !"),
    new_password: Yup.string()
      .required("New Password is required !")
      .min(6, "Password length at least 6.")
      .matches(/[0-9]/, "Password requires a number")
      .matches(/[a-z]/, "Password requires a lowercase letter")
      .matches(/[A-Z]/, "Password requires an uppercase letter")
      .matches(/[^\w]/, "Password requires a special character"),
    confirm_new_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Confirm password must be same as password")
      .required("Confirm Password is required !"),
  });
  const handleSubmit = async (values) => {
    let response = await changePassword(values);
    if (response?.status === 200) {
      formik.resetForm();
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });
  return (
    <>
      <Card id="change-password">
        <MDBox p={3}>
          <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
            Change Password
          </MDBox>
        </MDBox>
        <MDBox onSubmit={formik.handleSubmit} component="form" pb={3} px={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDInput
                type="password"
                value={formik.values.old_password}
                label="Old Password (જુનો પાસવર્ડ દાખલ કરો)"
                name="old_password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.old_password && formik.errors.old_password ? (
                <Box component="p" sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  {formik.errors.old_password}
                </Box>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12}>
              <MDInput
                type="password"
                value={formik.values.new_password}
                label="New Password (નવી પાસવર્ડ દાખલ કરો)"
                name="new_password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.new_password && formik.errors.new_password ? (
                <Box component="p" sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  {formik.errors.new_password}
                </Box>
              ) : (
                ""
              )}
            </Grid>
            <Grid item xs={12}>
              <MDInput
                type="password"
                value={formik.values.confirm_new_password}
                label="Confirm Password (પાસવર્ડની પુષ્ટિ કરો)"
                name="confirm_new_password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.confirm_new_password && formik.errors.confirm_new_password ? (
                <Box component="p" sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                  {formik.errors.confirm_new_password}
                </Box>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <MDBox mt={6} mb={1}>
            <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
              Password requirements (પાસવર્ડના નિયમો)
            </MDBox>
          </MDBox>
          <MDBox mb={1}>
            <MDTypography variant="body2" color="text">
              Please follow this guide for a strong password
            </MDTypography>
          </MDBox>
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="flex-end"
            flexWrap="wrap"
          >
            <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
              {renderPasswordRequired}
            </MDBox>
            <MDBox ml="auto" mt="30px" sx={{ display: "contents" }}>
              <SubmitButton btnText="update password" type="submit" />
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </>
  );
};

export default ChangePassword;
